import { RouteComponentProps } from 'react-router-dom';
import { IUserType, UserRoles } from 'types/profile.types';

export const getUserRole = (role: string) => {
  let result: string = '';
  switch (role) {
    case '1':
      result = UserRoles.SUPER_USER;
      break;
    case '2':
      result = UserRoles.ADMIN_USER;
      break;
    case '3':
      result = UserRoles.GENERAL_USER;
      break;
    default:
      result = role.toString();
      break;
  }

  return result;
};

type URLParams = { id?: string };

export interface IOCRouteComponentProps extends RouteComponentProps<URLParams> {
  user: IUserType;
}
